var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2500px",
    height: "1270px",
    viewBox: "0 0 2500 1270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "B",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M2298.3837,244.53627 L2298.3837,777.466113 L2049.97241,777.851754 L2049.97241,1185.46373 L1759.23935,1185.46373 L1759.23935,244.53627 L2298.3837,244.53627 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426",
    transform: "translate(2028.811525, 715.000000) scale(-1, 1) translate(-2028.811525, -715.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M989.404404,59.1644315 L1258.28517,323.896631 L1489.1039,323.896631 L1489.1039,245.44555 L1759.16275,244.54144 L1756.17203,1122.46479 L982.175101,1123.00129 L982.175101,780.846612 L737.80056,780.846612 L737.80056,1122.7231 L149.595494,1125.45657 L149.595494,833.53627 L207.618703,833.53627 L207.618703,575.53627 L461.72093,575.53627 L461.625001,323.896631 L719.467279,323.896631 L719.467279,249.324559 L799.325876,249.324559 L989.404404,59.1644315 Z",
    stroke: "#FFD426",
    strokeWidth: 3.07254098,
    fillOpacity: 0.2,
    fill: "#FFD426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor2);
export default __webpack_public_path__ + "static/media/select-floor-2.bc003b87.svg";
export { ForwardRef as ReactComponent };